import React, { useEffect, useState } from 'react'
import classnames from "classnames";
import Styles from "./styles.module.scss";
import { Icon } from "@iconify/react";
import DateRangePicker  from "../../components/daterangePicker";
import { convertMilliSecToDateNew, findFilterDate, getMilliSecUTC } from '../../utils/EllowUtils';

interface props  {
  applyDurationFilter?: any;  
}

const TimsheetDurationFilter: React.FC<props> =  ({
  applyDurationFilter
}) => {

    // "duration": data.dateWithin && { "from": data.dateWithin.from, "to": data.dateWithin.to },
    const [isActive, setActive] = useState<boolean>(true);
    const [activeButton, setActiveButton] = useState<number>(0)
    const [appliedFilter, setAppliedFilter] = useState<any>()
    const [date, setDate] = useState<{from: number, to: number}>()
    const ToggleClass = () => {
      setActive(!isActive); 
     };

    useEffect(() => {    
        if (date) {
          applyDurationFilter(date)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date])
    
    
    const handleChange = (value: any, name: string) => {
     
        if (activeButton === value) {
            setActiveButton(0)
            setAppliedFilter(undefined) 
            applyDurationFilter()
            ToggleClass()
           return
        }

        if (name !== 'date') {
            setActiveButton(value)
            setDate({ from: getMilliSecUTC(findFilterDate(value)?.from), to: getMilliSecUTC(findFilterDate(value)?.to) })
            ToggleClass()
            setAppliedFilter(name)
        }
        else {
            setActiveButton(0)
            if (value.start && value.end) {
                setDate({ from: getMilliSecUTC(value.start), to: getMilliSecUTC(value.end) })  
              //  applyDashboardFilter(date)
              //  ToggleClass()
                setAppliedFilter(convertMilliSecToDateNew(value.start).slice(3) + ' - ' + convertMilliSecToDateNew(value.end).slice(3))
            }

        }
    }

    const onBlur = (e: any) => {
              if (!e.target.value) {
            ToggleClass()
        }
  }

    return (
      
        <div className={Styles.notiWithSort}>
           <div className={Styles.sortButton}>
                <button className={!appliedFilter ? Styles.button : Styles.buttonAct} onClick={ToggleClass}><Icon icon="fa6-regular:clock" />{appliedFilter ? appliedFilter : 'Last 1 Month'}<Icon icon="charm:chevron-down" /></button>
          <div className={isActive ? Styles.sortDropdown : Styles.sortDropdownAct}>
            <div className={classnames("breakDateInput", Styles.sortDate)}>
                <DateRangePicker  defaultShow={false} onChange = {(e: any) => handleChange(e.target.value,'date')} onBlur={onBlur} />
            </div>
            <div className={Styles.sortItems}>
              <button onClick={() => handleChange(2,'Last 1 Month')} className={activeButton === 2 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 1 Month</button>
              <button onClick={() => handleChange(3,'Last 3 Months')} className={activeButton === 3 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 3 Month</button>
              <button onClick={() => handleChange(4,'Last 6 Months')} className={activeButton === 4 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 6 Month</button>
              <button onClick={() => handleChange(5,'Last 1 Year')} className={activeButton === 5 ? classnames(Styles.active,Styles.sortBtn) : Styles.sortBtn}>Last 1 Year</button>
            </div>
            
          </div>
        </div>


    </div>
  )
}

export default TimsheetDurationFilter